"use client";

import { ENRICH_OAUTH_SCOPES, helpEmail, homepagePath } from "@/lib/config";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useSearchParams } from "next/navigation";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ShieldAlert } from "lucide-react";
import GoogleAuthButton from "@/components/auth/GoogleAuthButton";
import React, { useState } from "react";

export default function LoginPage() {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") || homepagePath;
  const authError = searchParams.get("authError");
  const [errorMessage, setErrorMessage] = useState<string | null>(authError);

  return (
    <main className="min-h-screen flex flex-col justify-center items-center">
      <div className="flex flex-col items-center justify-center space-y-6 sm:w-[350px]">
        {errorMessage && (
          <Alert
            variant="destructive"
            className="animate-in slide-in-from-top-5 fade-in duration-1000"
          >
            <ShieldAlert className="h-4 w-4" />
            <AlertTitle>Auth Error</AlertTitle>
            <AlertDescription>
              {errorMessage}. Try again or contact Cape at{" "}
              <span className="text-foreground">hello@joincape.ai</span>
            </AlertDescription>
          </Alert>
        )}

        <div>
          <Image alt="logo" src="/images/logo.svg" height="40" width="40" />
        </div>

        <h1 className="text-2xl font-semibold tracking-tight align-top">
          <span className="">Welcome to Cape</span>
        </h1>

        <div className={cn("grid gap-6")}>
          <div className="mx-auto">
            <GoogleOAuthProvider
              clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || ""}
            >
              <GoogleAuthButton
                redirectTo={callbackUrl}
                setErrorMessage={setErrorMessage}
                shouldLogin={true}
              />
            </GoogleOAuthProvider>
          </div>
          <div className="flex flex-col items-center justify-center animate-in fade-in duration-500 slide-in-from-top-5">
            <div>Don&apos;t have Google for your company? </div>
            <div>
              <a
                href={`mailto:${helpEmail}`}
                className="hover:cursor-pointer text-center"
              >
                <p className="font-medium text-primary">
                  Email {helpEmail} for access.
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
